var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menuLateralDrawer)?_c('div',{staticClass:"wall",on:{"click":function($event){return _vm.toggleMenu()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }